import { loadItem, saveItem, storageKeys } from "../storage/index";
import { checkUsernameAvailability as checkUsernameAvailabilityApi } from "../../api/profileApi";
import { isPreviewAuthEnabled } from "../../features/auth/previewAuth";

const USERNAME_PATTERN = /^[a-z0-9_]{3,30}$/;
const RESERVED_USERNAMES = new Set([
  "admin",
  "support",
  "help",
  "greydates",
  "official",
  "moderator",
  "null",
  "undefined",
]);

export function normalizeUsername(value = "") {
  return String(value).trim().replace(/^@+/, "").toLowerCase();
}

export function isValidUsernameFormat(username) {
  return USERNAME_PATTERN.test(username);
}

function loadUsernameRegistry() {
  const stored = loadItem(storageKeys.usernames, {});
  return stored && typeof stored === "object" ? stored : {};
}

export function registerUsername(username, userId) {
  const normalized = normalizeUsername(username);
  if (!normalized || !userId) return;
  const registry = loadUsernameRegistry();
  registry[normalized] = userId;
  saveItem(storageKeys.usernames, registry);
}

export function checkUsernameAvailability(username, { currentUsername, userId } = {}) {
  const normalized = normalizeUsername(username);
  const current = normalizeUsername(currentUsername);

  if (!normalized) {
    return { available: false, error: "Choose a username." };
  }

  if (!isValidUsernameFormat(normalized)) {
    return {
      available: false,
      error: "Use 3–30 characters: lowercase letters, numbers, and underscores only.",
    };
  }

  if (RESERVED_USERNAMES.has(normalized)) {
    return { available: false, error: "This username is not available." };
  }

  const registry = loadUsernameRegistry();
  const owner = registry[normalized];
  if (owner && owner !== userId && normalized !== current) {
    return { available: false, error: "This username is already taken." };
  }

  return { available: true, username: normalized };
}

export async function checkUsernameAvailabilityRemote(username, options = {}) {
  const localResult = checkUsernameAvailability(username, options);
  if (!localResult.available || isPreviewAuthEnabled()) {
    return localResult;
  }

  try {
    return await checkUsernameAvailabilityApi(localResult.username);
  } catch {
    return localResult;
  }
}
